/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RoomsUpdateRequestDto = {
  /**
   * Room name
   */
  name: RoomsUpdateRequestDto.name;
  /**
   * Custom room name when the main name is OTHER
   */
  customName?: string;
};
export namespace RoomsUpdateRequestDto {
  /**
   * Room name
   */
  export enum name {
    LIVING_ROOM = 'LIVING_ROOM',
    BEDROOM = 'BEDROOM',
    KITCHEN = 'KITCHEN',
    BATHROOM = 'BATHROOM',
    CHILDS_ROOM = 'CHILDS_ROOM',
    GARAGE = 'GARAGE',
    SUMMER_HOUSE = 'SUMMER_HOUSE',
    OTHER = 'OTHER',
  }
}

